import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'openLink']

  declare readonly inputTarget: HTMLInputElement
  declare readonly openLinkTarget: HTMLAnchorElement

  connect (): void {
    this.sync()
  }

  sync (): void {
    const url = this.validUrl(this.inputTarget.value)
    const link = this.openLinkTarget
    const enabled = url !== null

    if (enabled) {
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
    } else {
      link.removeAttribute('href')
      link.removeAttribute('target')
      link.removeAttribute('rel')
    }

    link.classList.toggle('pointer-events-none', !enabled)
    link.classList.toggle('opacity-40', !enabled)
    link.setAttribute('aria-disabled', enabled ? 'false' : 'true')

    const icon = link.querySelector('svg')
    if (icon !== null) {
      icon.classList.toggle('text-accent', enabled)
      icon.classList.toggle('text-muted', !enabled)
    }
  }

  private validUrl (value: string): string | null {
    const trimmed = value.trim()
    if (trimmed === '') return null

    try {
      const uri = new URL(trimmed)
      return (uri.protocol === 'http:' || uri.protocol === 'https:') && uri.host !== '' ? trimmed : null
    } catch {
      return null
    }
  }
}
